<template>
    <div class="w-100">
      <Tables ref="tableRelatorioPitQMA"
                  :columns= columnQMA
                  :showSearch="false"
                  :showPrint="false"
                  :newHeaderStatus="true"
                  :showDownload="false"
                  :showFullscreen="false"
                  v-on:Load="onLoad"
                  style="font-family: 'Segoe UI'">
                  <tr v-for="(obj,index) in dataRelatoioQma" :key="index">
                  <TableColumn :IsText="true"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.codQma != null ? obj.codQma: 'N/D'" />
                  <TableColumn :IsText="true"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.revisao != null ? obj.revisao: 'N/D'" />
                  <TableColumn :IsText="true"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.servicos != null ?  obj.servicos :  'N/D'" />
                  <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.codigoObra"></TableColumn>
                  <TableColumn v-on:Edit="onSelect(obj)" :IsText="true"  :value="obj.codigoReferencia"></TableColumn>
                  <TableColumn :IsText="true"  v-on:Edit="onSelect(obj)" :status="1" :value="obj.responsavel != null ? obj.responsavel: 'N/D'" />
                  <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="1" :value="obj.dataCriacao != null ? obj.dataCriacao : 'N/D'" />
                  <TableColumn :IsText="true"   v-on:Edit="onSelect(obj)" :status="1" :value="obj.dataAprovacao != null && obj.dataAprovacao != '' ? obj.dataAprovacao : 'N/D'" />
                  </tr>
                  <template #ButtonsAprova>
                  <div class="buttons-table-action">
                      <button class="btn-generate-lote" @click="gerarPDF()"><i class="fas fa-file-pdf"></i> EXPORTAR PDF</button>
                  </div>
                  </template>

      </Tables>
      <QmaReportPDF :report="report" ref="refQmaPdf" :filtros="dadosFiltro" :formSearch="formSearch" :dataRelatoioQma="dataRelatoioQma" :contagemPendentes="contagemPendentes" :dataRelatoioQmaLength="dataRelatoioQmaLength"></QmaReportPDF>
     </div>

  </template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import QmaReportPDF from '@/views/private/qma/qmaReport/components/qmaReportTable/components/qmaReportPdf/qmaReportPdf.vue'
// import aprReport from '@/shared/http/repositories/business/aprReport'
import reportQmaRepository from '@/shared/http/repositories/business/qmaReportRepository.js'
import { toast, loading } from '@/shared/utils/UIHelper'

export default {
  name: 'qmaReportPitTable',
  components: {QmaReportPDF},
  mixins: [ActionsForm],
  props: ['report'],
  data () {
    return {
      columnQMA: ['CÓDIGO PIT', 'REVISÃO', 'ATIVIDADE', 'Código Obra', 'Descrição Obra', 'RESPONSÁVEL', 'DATA DE APLICAÇÃO', 'DATA APROVAÇÃO'],
      dataRelatoioQma: [],
      formSearch: {
        Fluxo: this.report,
        numeroQma: null,
        ResponsavelId: null,
        TemplateItemAvaliacaoId: null,
        DataInicioAPR: null,
        DataFimAPR: null,
        ObraId: null
      },
      dadosFiltro: {},
      quantitativosPDF: {},
      contagemPendentes: 0,
      dataRelatoioQmaLength: 0
    }
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    onLoad () {
      reportQmaRepository.GetAllQmaReport(this.$refs.tableRelatorioPitQMA.pagingLimit, this.$refs.tableRelatorioPitQMA.pagingIndex, this.formSearch)
        .then((Response) => {
          loading.pop()
          this.$refs.tableRelatorioPitQMA.LoadAllByData(Response)
          this.dataRelatoioQma = Response.data.data
          this.dataRelatoioQmaLength = Response.data.data.length
          if (Response.data.data.length > 0) {
            this.contagemPendentes = this.dataRelatoioQma.filter(item => item.statusQma <= 1).length
            this.$emit('dataRelatoioQmaLength', this.dataRelatoioQmaLength)
            this.$emit('contagemPendentes', this.contagemPendentes)
            this.dadosFiltro = Response.data.data[0].filtrosAplicados
          } else {
            this.contagemPendentes = 0
            this.$emit('dataRelatoioQmaLength', this.dataRelatoioQmaLength)
            this.$emit('contagemPendentes', this.contagemPendentes)
          }
        })
        .catch(Erro => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    },
    gerarPDF () {
      // this.$refs.refQmaPdf.quantitativos = this.quantitativosPDF
      // this.$refs.refQmaPdf.filtros = this.dadosFiltro
      // this.$refs.refQmaPdf.formSearch = this.formSearch
      // this.$refs.refQmaPdf.GetAllRelatorioAPRPDF()
      this.$refs.refQmaPdf.generatePDF()
    }
  }
}
</script>

    <style scoped>
    .btn-generate-lote {
        height: 2rem;
        padding: 0 1rem;
        background: #008144;
        color: white;
        border-radius: 4px;
        border: none;
        font-size: 12px;
    }
    .btn-generate-lote:hover{
        background: #024d2a;
    }
    </style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaReport/qmaReportPit/components/qmaReportPitTable/qmaReportPitTable.vue